export function formatMoney(value, currency) {
    return new Intl.NumberFormat(currency === "USD" ? 'en-US' : 'de-DE', { style: 'currency', currency: currency }).format(value)
}